export const SelectStyles = {
  indicatorSeparator: () => ({
    display: "none",
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: 48,
    borderRadius: 12,
    borderColor: state.isFocused ? '#039be5' : '#E7E7E7',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(3, 155, 229, 0.15)' : 'none',
    paddingLeft: 4,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: state.isFocused ? '#039be5' : '#E7E7E7',
    },
  }),
  dropdownIndicator: (baseStyles, state) => ({
    ...baseStyles,
    transition: 'transform 0.2s ease',
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0)",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    height: 46,
    color: "#000",
    overflow: "visible",
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    padding: 0,
    margin: 0,
    '& input': {
      boxShadow: 'none !important',
      outline: 'none !important',
    },
  }),
  menu: (base) => ({
    ...base,
    animation: 'fadeInMenu 0.15s ease',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 200,
  }),
};

export const icalUrlRegex =
  /^(webcal|https?):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}([a-zA-Z0-9\-_~:\/?#\[\]@!$&'()*+,;=%\.]*)?$/;

export const MultiSelectStyles = {
  indicatorSeparator: () => ({
    display: "none",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#039BE5",
    borderRadius: "8px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    padding: "0 0.5rem",
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: "#fff",
    fontSize: "14px",
    textAlign: "center",
    padding: "0 0.5rem",
  }),
  multiValueRemove: () => ({
    color: "#fff",
    fontSize: "18px",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    input: {
      flex: 1,
    },
  }),
};
